import Icon from '../components/Icon.vue'

Icon.register({"bolt":{"width":320,"height":512,"paths":[{"d":"M296 160H180.6L215.2 30.2C219.3 15 207.8 0 192 0H56C44 0 33.8 8.9 32.2 20.8L0.2 260.8C-1.7 275.2 9.5 288 24 288H142.7L96.6 482.5C93 497.6 104.7 512 120 512 128.3 512 136.4 507.6 140.8 500L316.7 196C326 180.1 314.5 160 296 160z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/bolt.js
// module id = null
// module chunks = 